import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {events} from 'lib';
import session from 'services/sessionService';
import PoolApi from 'api/pool';
import TruBlueApi from 'api/truBlue';
import waterTesterApi from 'api/waterTester';
import Customer from 'models/customer';
import {truBlueStatus, countries, productTypes} from 'helpers/constants';
import {Col, Row} from 'components';
import {Button} from 'components/layout';
import {Input} from 'components/forms';
import EditableCheckbox from 'components/forms/editableCheckbox';
import TruBlueModal from './trublue/truBlueModal';
import TruBlueAssignSystem from './trublue/truBlueAssignSystem';
import {Creatable} from 'react-select';
import ValidationGroup, {isValidEmail} from 'helpers/validation';
import {isProductTruBlue} from 'helpers/truBlue';
import {FormattedMessage, FormattedHTMLMessage, injectIntl} from 'react-intl';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import LayoutSelect from 'components/forms/layoutSelect.jsx';

class TruBlueRegistration extends Component {

  static propTypes = {
    customer: PropTypes.object,
    dealer: PropTypes.object,
    products: PropTypes.array,
    setCustomer: PropTypes.func,
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
    intl: PropTypes.any,
  };

  state = {
    pools: [],
    products: this.props.products,
    customer: this.props.customer.clone(),
    customerEmails: [],
    customerEmailsWorkingBackup: [],
    email: null,
    invalidEmail: false,
    selectedPools: [],
    newEmail: false,
    optInBiolabEmails: false,
    optInDealerEmails: false,
    testers: [],
  };

  componentWillMount() {
    let {formatMessage} = this.props.intl;

    this.group = new ValidationGroup(this.save);
    this.setCustomerEmails(this.props.customer);

    let apis = [
      PoolApi.getList(this.props.customer.id),
      waterTesterApi.getWaterTesters(),
    ];

    Promise.all(apis).then(([pools, testers]) => {
      testers = testers || [];

      // Add a blank water tester
      if (testers.length && testers[0].key !== -1) {
        testers = [{key: '', name: formatMessage({id: 'scanning.select.tester'})}].concat(testers);
      }

      this.setState({
        pools,
        testers: testers || [],
      });

    }).catch(err => {
      console.error(err);
      events.publish('error.user', {message: 'Failed to get pools.'});
      this.onClose();
    });

    TruBlueApi.getConfig().then(config => {
      this.setState({config: config});
    });
  };

  setCustomerEmails = customer => {
    let customerEmails = customer.customerContacts.reduce((emails, contact) => {
      if (contact.email) {
        emails.push({label: contact.email, value: contact.email});
      }
      return emails;
    }, []);

    this.setState({
      customerEmails,
      customerEmailsWorkingBackup: cloneDeep(customerEmails),
      email: customerEmails.length > 0 ? customerEmails[0] : null,
    });

  };

  save = () => {
    if (!this.enabledSubmit()) {
      return;
    }

    let {onClose, onSuccess, dealer} = this.props;
    let {formatMessage} = this.props.intl;
    let {customer, email, invalidEmail, selectedPools, products} = this.state;

    if (invalidEmail) {
      this.emailSelect.focus();
    } else {
      onClose();

      let pools = selectedPools.map(p => {
        let isSanitizerTruBlue = isProductTruBlue(products, productTypes.sanitizer, dealer, p.chemicalBaseTypeID, p.sanitizer);
        let isMaintOxidizerTruBlue = isProductTruBlue(products, productTypes.maintOxidizer, dealer, p.chemicalBaseTypeID, p.maintOxidizer);
        let isPrevAlgicideTruBlue = isProductTruBlue(products, productTypes.prevAlgicide, dealer, p.chemicalBaseTypeID, p.prevAlgicide);
        let isMaintClarifierTruBlue = isProductTruBlue(products, productTypes.maintClarifier, dealer, p.chemicalBaseTypeID, p.maintClarifier);

        p.hasAllTruBlueProducts = isSanitizerTruBlue && isMaintOxidizerTruBlue && isPrevAlgicideTruBlue && isMaintClarifierTruBlue;
        return p;
      });

      TruBlueApi.registerCustomer(customer, pools, email && email.value)
        .then(res => {
          if (!res.success) {
            throw new Error(`${formatMessage({id: 'trublue.modal.registration.failed'})}`);
          }

          for (let pool of this.state.pools) {
            session.deletePool(pool);
          }

          this.props.setCustomer(Customer.fromApiFormat(res.data));
          onSuccess();
        })
        .catch(err => {
          console.error(err);
          events.publish('error.user', {message: `${formatMessage({id: 'trublue.modal.registration.failed'})}`});
        });
    }
  };


  onPoolChange = (pool, isBeingSelected = null) => {
    let {selectedPools} = this.state;

    if (isBeingSelected === true) {
      selectedPools.push(pool);
      this.setState({selectedPools});
      return;
    }

    if(isBeingSelected === false) {
      this.setState({selectedPools: selectedPools.filter(p => p.id !== pool.id)});
      return;
    }

    //update
    const index = selectedPools.findIndex(p => p.id === pool.id);

    if(index > -1) {
      selectedPools[index] = pool;
      this.setState({selectedPools});
    }

  };

  emailChange = value => {
    const customerEmailoptions = this.state.customerEmailsWorkingBackup;

    this.setState({
      email: value,
      invalidEmail: false,
      newEmail: value && !(customerEmailoptions || []).some(c => c.value === value.value),
    });
  };

  isValidNewOption = option => option && (option.label || '').trim().length > 0 ?
    isValidEmail(option.label) :
    false;

  optionRenderer = item => <span title={item.label}>{item.label}</span>;

  onCustomerChange = e => {
    let customer = this.state.customer;
    let keys = Object.keys(customer);

    if (keys.includes(e.key)) {
      customer[e.key] = e.value;
    }

    this.setState({customer});
  };


  validateSubmit = () => {
    let {email} = this.state;

    if (email && email.value && this.emailSelect && !isValidEmail(email.value)) {
      this.setState({invalidEmail: true});
    }

    this.group.validate();

  };

  enabledSubmit = () => {
    let {invalidEmail, selectedPools} = this.state;
    let checkedPoolsNumber = selectedPools.length;

    return !invalidEmail && checkedPoolsNumber >= 1;
  };

  render() {
    let {pools, products, email, customer, customerEmails, invalidEmail, newEmail, optInDealerEmails, optInBiolabEmails, testers} = this.state;
    let {onClose} = this.props;
    let {formatMessage, formatNumber} = this.props.intl;

    return <TruBlueModal onClose={onClose}>
      <div className='trublue-modal__section'>
        <h1 className='trublue-modal__section-title'>
          <FormattedMessage id='trublue.registration.year'
                            values={{year: moment().year()}}/>
        </h1>
        <p className='trublue-modal__section-subtitle'><FormattedHTMLMessage id='trublue.modal.membership.subtitle'/></p>
        <div className='truBlue-membership'>
          <Row>
            <Col md={4}>
              <LayoutSelect label={formatMessage({id: 'general.trublue.storeAssociate'})}
                    editMode
                    dataChanged={this.onCustomerChange}
                    dataKey='storeAssociateTBSignUp'
                    keys={testers.map(t => t.name)}
                    options={testers.map(t => t.name)}
                    value={customer.storeAssociateTBSignUp}/>
            </Col>
            <Col md={4}>
              <div className='form-group'>
                <label><FormattedMessage id='general.email'/></label>
                <Creatable
                  ref={r => this.emailSelect = r}
                  name='email'
                  options={customerEmails}
                  value={email}
                  autosize={false}
                  placeholder=''
                  className={`trublue-email-select ${invalidEmail ? 'trublue-email-select-error' : '' }`}
                  isValidNewOption={this.isValidNewOption}
                  onChange={this.emailChange}
                  optionRenderer={this.optionRenderer}
                  inputProps={{'maxLength': 50, className: `${invalidEmail ? 'error' : '' }`}}
                  noResultsText={formatMessage({id: 'trublue.modal.membership.noemailoptions'})}
                  promptTextCreator={label => `${formatMessage({id: 'trublue.modal.membership.createemailoption'})} '${label}'`}/>
              </div>
            </Col>
          </Row>
          {this.props.dealer.country === countries.CA && !!email && !!email.value && !invalidEmail && newEmail ?
            <Row>
              <Col md={4}>
                <EditableCheckbox editMode={true} value={optInBiolabEmails} required group={this.group} onChange={(event) => this.setState({optInBiolabEmails: event.value})}>
                  <FormattedMessage id="customer.contact.casl.optInBiolabEmails" />
                </EditableCheckbox>
              </Col>
              <Col md={4}>
                <EditableCheckbox editMode={true} value={optInDealerEmails} required group={this.group} onChange={(event) => this.setState({optInDealerEmails: event.value})}>
                  <FormattedMessage id="customer.contact.casl.optInDealerEmails" />
                </EditableCheckbox>
              </Col>
            </Row>  :
          null}
        </div>
      </div>
      <div className='trublue-modal__section'>
        <h1 className='trublue-modal__section-title'>
          <FormattedMessage id='trublue.modal.systemselection.title'/>
        </h1>
        <p className='trublue-modal__section-subtitle'>
          <FormattedMessage id='trublue.modal.systemselection.firstsubtitle'/>
          <br/>
          <FormattedMessage id='trublue.modal.systemselection.secondsubtitle'/>
        </p>
        <div className='truBlue-selection'>
          {pools.filter(x => x.truBlueStatus !== truBlueStatus.Ineligible).map(pool =>
            <TruBlueAssignSystem pool={pool.clone()}
                                 key={pool.id}
                                 products={products}
                                 ref={'pool-' + pool.id}
                                 register={this.register}
                                 unregister={this.unregister}
                                 dealer={this.props.dealer}
                                 formatNumber={formatNumber}
                                 formatMessage={formatMessage}
                                 onPoolChange={this.onPoolChange}/>)}
        </div>
      </div>
      <div className='trublue-modal__controls'>
        <Button default
                onClick={onClose}
                style={{marginRight: 20}}><FormattedMessage id='general.cancel'/></Button>
        <Button primary
                onClick={this.validateSubmit}
                disabled={!this.enabledSubmit()}><FormattedMessage id='general.register'/></Button>
      </div>
    </TruBlueModal>;
  }
}


export default injectIntl(TruBlueRegistration);
